import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Facebook } from "lucide-react";
import { BOOK } from "@/lib/site";

const links = [
  { label: "Story", href: "#story" },
  { label: "Gallery", href: "#gallery" },
  { label: "Author", href: "#author" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      data-testid="site-navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,backdrop-filter,border-color] duration-500 ${
        scrolled
          ? "border-b border-white/10 bg-twilight/70 backdrop-blur-xl"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-12">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2">
          <span className="text-gold text-xl">✦</span>
          <span className="font-display text-lg font-semibold tracking-tight text-cream md:text-xl">
            Hannah&apos;s Heart Awakens
          </span>
        </a>
        <div className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-body text-sm text-slate-300 transition-colors duration-300 hover:text-gold"
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/blog"
            data-testid="nav-link-blog"
            className="font-body text-sm text-slate-300 transition-colors duration-300 hover:text-gold"
          >
            Blog
          </Link>
          <Link
            to="/resources"
            data-testid="nav-link-resources"
            className="font-body text-sm text-slate-300 transition-colors duration-300 hover:text-gold"
          >
            Resources
          </Link>
        </div>
        <div className="flex items-center gap-3">
          <a
            href={BOOK.facebook}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-facebook-link"
            aria-label="Follow Hannah Series Official on Facebook"
            className="grid h-9 w-9 place-items-center rounded-full border border-white/15 text-slate-300 transition-[border-color,color] duration-300 hover:border-gold hover:text-gold"
          >
            <Facebook className="h-4 w-4" />
          </a>
          <a
            href={BOOK.amazon}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-buy-cta"
            className="rounded-full border border-gold/50 bg-gold/10 px-5 py-2 font-body text-sm font-medium text-gold transition-[background-color,box-shadow] duration-300 hover:bg-gold hover:text-twilight hover:shadow-[0_0_20px_rgba(251,191,36,0.5)]"
          >
            Buy Now
          </a>
        </div>
      </nav>
    </motion.header>
  );
}
